export const spinners = [
	{
		id: 0,
		className: 'spinner0',
	},
	{
		id: 1,
		className: 'spinner1',
	},
	{
		id: 2,
		className: 'spinner2',
	},
	{
		id: 3,
		className: 'spinner3',
	},
	{
		id: 4,
		className: 'spinner4',
	},
	{
		id: 5,
		className: 'spinner5',
	},
	{
		id: 6,
		className: 'spinner6',
	},
	{
		id: 7,
		className: 'spinner7',
	},
	{
		id: 8,
		className: 'spinner8',
	},
	{
		id: 9,
		className: 'spinner9',
	},
	{
		id: 10,
		className: 'spinner10',
	},
	{
		id: 11,
		className: 'spinner11',
	},
	{
		id: 12,
		className: 'spinner12',
	},
	{
		id: 13,
		className: 'spinner13',
	},
	{
		id: 14,
		className: 'spinner14',
	},
];

export const spinnerColors = [
	{
		id: 0,
		color: '#781A8F',
	},
	{
		id: 1,
		color: '#2694C4',
	},
	{
		id: 2,
		color: '#DC396D',
	},
	{
		id: 3,
		color: '#6EBD45',
	},
];

export const getSpinnerStyles = (size: number, color: string) => ({
	width: `${size}px`,
	height: `${size}px`,
	['--spinner1-border-size']: `${size / 9.6}px`,
	['--spinner2-after-size']: `${size * 1.17}px`,
	['--spinner3-after-size']: `${size / 2}px`,
	['--spinner4-after-size']: `${size}px`,
	['--spinner5-after-size']: `${size}px`,
	['--spinner6-after-size']: `${size / 3.2}px`,
	['--spinner6-margin']: `${size / 4.8}px`,
	['--spinner7-after-size']: `${size / 2}px`,
	['--spinner8-after-size']: `${size / 2}px`,
	['--spinner9-after-size']: `${size / 2.4}px`,
	['--spinner9-margin']: `${size / 4.8}px`,
	['--spinner9-box-shadow']: `${size / 1.6}px`,
	['--spinner9-translate-size']: `${size / 3.2}px`,
	['--spinner9-margin-transform']: `-${size / 2.4}px`,
	['--spinner10-after-size']: `${size}px`,
	['--spinner11-after-size']: `${size / 1.26}px`,
	['--spinner11-before-size']: `${size / 1.71}px`,
	['--spinner12-background-size']: `${size / 4}px`,
	['--spinner12-rotate-full-size']: `${size}px`,
	['--spinner12-rotate-half-size']: `${size / 2}px`,
	['--spinner14-border-size']: `${size / 2}px`,
	['--spinner-color']: color,
});
